var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 15c-2.209 0-4-1.791-4-4v-5c0-2.209 1.791-4 4-4s4 1.791 4 4v5c0 2.209-1.791 4-4 4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.0558 13.0159c-.668-.191-1.4.092-1.716.711-.993 1.942-3.01 3.273-5.341 3.273-2.33098 0-4.34798-1.331-5.33998-3.273-.316-.619-1.048-.902-1.716-.711-.911.26-1.36 1.295-.922 2.135 1.201 2.308 3.378 4.01 5.979 4.604v.245c0 1.105.89498 2 1.99998 2s2-.895 2-2v-.245c2.601-.594 4.778-2.296 5.979-4.604.437-.84-.012-1.875-.923-2.135z",
    opacity: 0.35
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.d64f01010dc16c85ae64482eaa5dda9d.svg";
export { ForwardRef as ReactComponent };